// @ts-nocheck
import { FormModel, InputModel } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getForms = (state: ApplicationState) => {
    return state.foundation.components.form.forms;
};

export const getFormById = (state: ApplicationState, id: string): FormModel | null => {
    return getForms(state).find(x => x.id === id) || null;
};

export const getInputs = (state: ApplicationState, formId: string): InputModel[] => {
    return getFormById(state, formId)?.inputs || [];
};

export const getInputById = (state: ApplicationState, inputId: string | number, formId: string): InputModel | null => {
    return getInputs(state, formId)?.find(x => x.id === inputId) || null;
};

export const getFirstInputInError = (state: ApplicationState, formId: string): InputModel | null => {
    return getInputs(state, formId)?.find(x => x.error !== "") || null;
};

export const hasErrorInForm = (state: ApplicationState, formId: string) => {
    return getInputs(state, formId)?.some(x => x.error);
};
